import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      verifyToken();
    } else {
      setLoading(false);
    }
  }, []);

  const verifyToken = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem("token");
      delete axios.defaults.headers.common["Authorization"];
    } finally {
      setLoading(false);
    }
  };

  const loginCounselor = async (username, password) => {
    const response = await axios.post(`${API}/auth/login`, { username, password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const loginAdmin = async (password) => {
    const response = await axios.post(`${API}/auth/admin`, { password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const loginPool = async (password) => {
    const response = await axios.post(`${API}/auth/pool`, { password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const loginDietary = async (password) => {
    const response = await axios.post(`${API}/auth/dietary`, { password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const loginAthletics = async (password) => {
    const response = await axios.post(`${API}/auth/athletics`, { password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const loginHealth = async (password) => {
    const response = await axios.post(`${API}/auth/health`, { password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const loginSupervisor = async (username, password) => {
    const response = await axios.post(`${API}/auth/supervisor`, { username, password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const loginSpecialist = async (password) => {
    const response = await axios.post(`${API}/auth/specialist`, { password });
    const { token, ...userData } = response.data;
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userData);
    return userData;
  };

  const logout = async () => {
    try {
      // Tell backend to close the counselor login session (best effort)
      await axios.post(`${API}/auth/logout`).catch(() => {});
    } finally {
      localStorage.removeItem("token");
      delete axios.defaults.headers.common["Authorization"];
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginCounselor, loginAdmin, loginPool, loginDietary, loginAthletics, loginHealth, loginSupervisor, loginSpecialist, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
